// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ApiHighlightController from "./api_highlight_controller"
application.register("api-highlight", ApiHighlightController)

import DataPreviewController from "./data_preview_controller"
application.register("data-preview", DataPreviewController)

import GraphStatusController from "./graph_status_controller"
application.register("graph-status", GraphStatusController)

import IssnFormatController from "./issn_format_controller"
application.register("issn-format", IssnFormatController)

import JournalSearchController from "./journal_search_controller"
application.register("journal-search", JournalSearchController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)
